import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, input, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { TENANT_MODEL, TENANTSINTERFACE } from 'libs/models/src/lib/tenant';
import { TreeNode } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { TreeSelect, TreeSelectModule } from 'primeng/treeselect';

@Component({
  selector: 'multi-tenant-list',
  standalone: true,
  imports: [CommonModule,TreeSelectModule, StyleClassModule,ReactiveFormsModule],
  templateUrl: './multi-tenant-list.component.html',
  styleUrl: './multi-tenant-list.component.css',
  changeDetection: ChangeDetectionStrategy.Default
})
export class MultiTenantListComponent {
  @Input('selectionMode') selectionMode: string='single';
  @Input('showInActiveTenant') showInActiveTenant: boolean=true;
  @Input('selectedTenantId') selectedTenantId: number;
  @Input('styleClass') styleClass: string="w-full h-full bg-gray-800 border-none header__tenant-list ";
  @Input('isGlobal') isGlobal: boolean = false;
  @Output('emittedTenant') emittedTenant = new EventEmitter<TENANT_MODEL>();
  @Output('emittedTenants') emittedTenants = new EventEmitter<TENANT_MODEL[]>();
  @Output('unselectedTenant') unselectedTenant = new EventEmitter<TENANT_MODEL>();
  @ViewChild('treeSelect') treeSelect: TreeSelect;

  
  selectedTenantField: UntypedFormControl = new UntypedFormControl('');
  tenants: any[];
  filteredOptions: any[];
  tenantAccess: TENANT_MODEL[] = [];
  formGroup!: FormGroup;
  selectedNodes: any[] = [];
  formControlTenantId:number = 0;

  pageNames = [
    { name: 'tenants', url: '/admin/tenant-list' },
    { name: 'create-tenant', url: '/admin/tenant-list/create-tenant' },
  ];
  disableAllTenants:boolean = false;

  constructor(private store: Store, public cdr :ChangeDetectorRef, public router: Router  ){

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.handleRouteChange(event.url);
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      selectedTenants: new FormControl()
  });
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      if(this.showInActiveTenant === false) this.tenantAccess = tenant.accessed_tenant.filter((tenant) => tenant.status.toLowerCase() !== 'inactive');  
      else this.tenantAccess = tenant.accessed_tenant;
      this.getTreeViewData();
      const initialUrl = this.router.url;
      this.handleRouteChange(initialUrl);
      if (this.selectedTenantId > 0) {
        const selectedNode = this.findNodeByTenantId(this.tenants, this.selectedTenantId);
        if (selectedNode) {
            this.formGroup.get('selectedTenants')?.setValue(selectedNode);
        }
      }
    });
  }

  handleRouteChange(url: string): void {
    if (this.pageNames.find((page) => page.url === url.split('?')[0])) {
      this.disableAllTenants = true;
      this.getTreeViewData();
      const selectedNode = this.findNodeByTenantId(this.tenants, this.selectedTenantId);
      if (selectedNode) {
        this.formGroup.get('selectedTenants')?.setValue(selectedNode);
      }
    } else {
      this.disableAllTenants = false;
      this.getTreeViewData();
      const selectedNode = this.findNodeByTenantId(this.tenants, this.selectedTenantId);
      if (selectedNode) {
        this.formGroup.get('selectedTenants')?.setValue(selectedNode);
      }
      this.cdr.detectChanges();
    }
  }

  getTreeViewData() {
    const treeViewData:any[] = [];
    if(this.tenantAccess && this.tenantAccess.length <= 15){
    this.tenantAccess.forEach((tenant) => {
      const tenantNode = {
        label: tenant.name_primary_language,
        tenantid: tenant.id,
        data: tenant,
        selectable: this.disableAllTenants ? this.disableAllTenants : tenant.status.toLowerCase() === 'inactive' ? false : true,
        styleClass: this.disableAllTenants ? 'p-disabled' : tenant.status.toLowerCase() === 'inactive' ? 'p-disabled' : '',
        children: []
      };
      treeViewData.push(tenantNode);
    });
      if(this.disableAllTenants)
      {
        treeViewData.push( { label: 'Global', tenantid: 0, data: {id: 0, name_primary_language: 'Global'}, selectable: true, styleClass: '', children: [] });
      }
      else if(treeViewData.findIndex(o => o.label.toLowerCase() == 'global') > -1){
        treeViewData.splice(treeViewData.findIndex(o => o.label.toLowerCase() == 'global')!,1); 
      }
    }
    else{
      const alltenantStateCodes = this.tenantAccess.map((tenant) => {
        return { code: tenant.state, name: tenant.state_name };
      });
      // const alltenantStateCodes = this.tenantAccess.map((tenant) =>  (code= tenant.state, name= tenant.state_name));
      const distinctStateCodes = alltenantStateCodes.filter((value, index, self) => {
        return self.findIndex(v => v.code === value.code) === index;
      });
  
      if(this.disableAllTenants)
         distinctStateCodes.push( { code: 'Global', name: 'Global' });
      else if(distinctStateCodes.findIndex(o => o.code.toLowerCase() == 'global') > -1){
        distinctStateCodes.splice(distinctStateCodes.findIndex(o => o.code.toLowerCase() == 'global'),1);
      }
  
      let i = 0;
      for (const state of distinctStateCodes) {
        const citiesInState = Array.from(new Set(
          this.tenantAccess.filter((tenant) => tenant.state === state.code)
            .map((tenant) => { return { code: tenant.city, name: tenant.city_name } })
        ));
  
        const distinctCitiesInState = citiesInState.filter((value, index, self) => {
          return self.findIndex(v => v.code === value.code) === index;
        });
  
        const stateNode = {
          key: i,
          label: state.name,
          icon: 'fa fa-globe',
          children: new Array
        };
        let j = 0;
        for (const city of distinctCitiesInState) {
          const tenantsInCity = this.tenantAccess.filter((tenant) => tenant.state === state.code && tenant.city === city.code)
            .map((tenant) => ({
              label: tenant.name_primary_language,
              tenantid: tenant.id,
              data: tenant,
              selectable: this.disableAllTenants ? this.disableAllTenants : tenant.status.toLowerCase() === 'inactive' ? false : true,
              styleClass: this.disableAllTenants ? 'p-disabled' : tenant.status.toLowerCase() === 'inactive' ? 'p-disabled' : '',
              children: []
            }));
  
          stateNode.children.push({
            key: j,
            label: city.name,
            icon: '',
            children: tenantsInCity
          });
          j++;
        }
        treeViewData.push(stateNode);
        i++;
      }
    }
    this.tenants =  treeViewData;
    this.filteredOptions = treeViewData
    this.filteredOptions = this.getFilteredOptions();
    this.cdr.detectChanges();
  }

  findNodeByTenantId(nodes: any[], tenantId: number): TreeNode | null {
    if(this.disableAllTenants){
      return nodes.find((node) => node.label === 'Global');
    }
    else{
      for (const node of nodes) {
        if (node.tenantid === tenantId) {
          return node;
        }
        if (node.children) {
          const found = this.findNodeByTenantId(node.children, tenantId);
          if (found) {
            return found;
          }
        }
      }
      return null;
    }
   
  }

  async onNodeSelect(event:any)
  {
    if(this.selectionMode === 'multiple' || this.selectionMode === 'checkbox')
    {
      const selectedTenantNodes = this.formGroup.controls.selectedTenants.value as TreeNode[];
      console.log("Selected tenant nodes", selectedTenantNodes.map((node) => node.data));
      this.emittedTenants.emit(selectedTenantNodes.map((node) => node.data));
      this.cdr.detectChanges();
    }
    else {
      if(event.node.children.length === 0)
      {
        this.selectedTenantId = event.node.data.id;
        const selectedNode = this.findNodeByTenantId(this.tenants, this.selectedTenantId);
        if (selectedNode) {
            this.formGroup.get('selectedTenants')?.setValue(selectedNode);
        }
        await this.timeout(100);
        this.emittedTenant.emit(event.node.data);
      }
      else{
        const selectedNode = this.findNodeByTenantId(this.tenants, this.selectedTenantId);
        if (selectedNode) {
            this.formGroup.get('selectedTenants')?.setValue(selectedNode);
        }
        event.node.expanded = !event.node.expanded;
        this.toggleChildNodes(event.node, event.node.expanded);
      }
    } 
    this.cdr.detectChanges();
  }

  onNodeUnselect(event:any)
  {
    console.log("Unselected tenant nodes", event.node.data);
    this.unselectedTenant.emit(event.node.data.id);
    this.cdr.detectChanges();
  }

  toggleChildNodes(node: TreeNode, expand: boolean) {
    if (node.children) {
      node.children.forEach(child => {
        child.expanded = expand;
        this.toggleChildNodes(child, expand); // Recursively toggle child nodes
      });
    }
  }

  filterLastChildren(treeData: TreeNode[]): TreeNode[] {
    const lastChildren: TreeNode[] = [];

    function traverse(node: TreeNode) {
      if (node.children && node.children.length > 0) {
        // node.children.forEach((child) => {
        //   traverse(child);
        // });
      } else {
        lastChildren.push(node);
      }
    }

    treeData.forEach((node) => {
      traverse(node);
    });
    return lastChildren;
  }

  getFilteredOptions() {
    const selectedTenants = this.formGroup.get('selectedTenants')?.value || [];
    // Ensure selectedTenants is an array
    const selectedTenantsArray = Array.isArray(selectedTenants) ? selectedTenants : [selectedTenants];
    if(this.disableAllTenants)
      return this.tenants.filter((tenant: any) => tenant.label.toLowerCase() !== 'global');
    else return this.tenants.filter((tenant: any) => !selectedTenantsArray.includes(tenant));
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
